webpackJsonp([1],{

/***/ "+BTi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+vln":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"subsidebar"}},[(_vm.isLoadedData)?[_c('sub-sidebar-header',{attrs:{"searchValue":_vm.searchValue},on:{"update:searchValue":function($event){_vm.searchValue=$event},"onSwitchRepoSort":_vm.handleSwitchRepoSort}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.repos.length),expression:"repos.length"}],staticClass:"repo-list"},_vm._l((_vm.repos),function(repo){return _c('repo',{key:repo.id,class:{ active: repo.id === _vm.activeRepo.id },attrs:{"repo":repo}})})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.repos.length),expression:"!repos.length"}],staticClass:"no-match vc-p"},[_c('i',{staticClass:"fa fa-bell-o fa-3x",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('p',{staticClass:"ttc"},[_vm._v(_vm._s(_vm.$t('noMatchingReposigory')))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-hand-o-left fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('switchTagOrAdjustSearch')))]),_vm._v(" "),_c('i',{staticClass:"fa fa-hand-o-up fa-lg",attrs:{"aria-hidden":"true"}})])])]:_c('div',{staticClass:"loader vc-p"},[_c('i',{staticClass:"fa fa-cog fa-spin fa-2x"}),_vm._v(" "),_c('p',{staticClass:"ttc"},[_vm._v(_vm._s(_vm.$t('gettingStarredRepository')))])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/9Mk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/I4U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/QRR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagNavHeader_vue__ = __webpack_require__("Ogc7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a86b831_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagNavHeader_vue__ = __webpack_require__("lQzl");
function injectStyle (ssrContext) {
  __webpack_require__("/9Mk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a86b831"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagNavHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a86b831_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagNavHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/ULj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("OMN4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__("9Tyx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper__ = __webpack_require__("oGFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__("n5Qe");






// import { getRepoReadme, getRenderedReadme } from '../api'


var repoReadmeSource = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.CancelToken.source();
var renderedReadmeSource = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.CancelToken.source();
var defaultTags = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].defaultTags,
    tagCategorys = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].tagCategorys;

var showdown = __webpack_require__("HKE2");
var converter = new showdown.Converter();

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    repos: [],
    active: {},
    readme: ''
  },
  getters: {
    untaggedRepos: function untaggedRepos(state) {
      return state.repos.filter(function (repo) {
        return !repo._customTags.length;
      });
    },
    reposOfTag: function reposOfTag(state, getters, rootState) {
      var repos = state.repos;
      var tag = rootState.tag.active;
      var categoryId = tag.categoryId,
          tagId = tag.id,
          tagName = tag.name;


      if (tagId === defaultTags.all.id) return repos;
      if (tagId === defaultTags.untagged.id) return getters.untaggedRepos;
      if (categoryId === tagCategorys.language.id) return repos.filter(function (repo) {
        return repo.language === tagName;
      });

      return repos.filter(function (repo) {
        return repo._customTags.find(function (_tag) {
          return _tag.id === tag.id;
        });
      });
    }
  },
  mutations: {
    initRepos: function initRepos(state, repos) {
      state.repos = repos;
    },
    switchActive: function switchActive(state, repo) {
      state.active = repo;
    },
    changeReadme: function changeReadme(state, readme) {
      state.readme = readme;
    },
    addRepoTag: function addRepoTag(state, tag) {
      state.active._customTags.push(tag);
    },
    insertRepoTag: function insertRepoTag(state, _ref) {
      var repo = _ref.repo,
          tag = _ref.tag,
          tagIndex = _ref.tagIndex;

      repo._customTags.splice(tagIndex, 0, tag);
    },
    popRepoTag: function popRepoTag(state) {
      state.active._customTags.pop();
    },
    deleteRepoTag: function deleteRepoTag(state, _ref2) {
      var repoId = _ref2.repoId,
          tagIndex = _ref2.tagIndex;

      var repo = state.repos.find(function (repo) {
        return repo.id === repoId;
      });
      repo._customTags.splice(tagIndex, 1);
    },
    deleteReposTag: function deleteReposTag(state, tagId) {
      state.repos.forEach(function (repo) {
        var tags = repo._customTags;

        var index = tags.findIndex(function (tag) {
          return tag.id === tagId;
        });
        if (index >= 0) tags.splice(index, 1);
      });
    }
  },
  actions: {
    switchActive: function switchActive(_ref3, repo) {
      var _this = this;

      var state = _ref3.state,
          commit = _ref3.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref4, content, readme, response;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit('switchActive', repo);
                commit('changeReadme', '');

                /**
                 * 用户快速切换 repository 时会导致 readme 内容错误
                 * 因为 Github Api 返回的结果在时间上是不确定的
                 *
                 * 假设用户快速切换 repository 的顺序是 A > B > C
                 * 可能存在 Repo A 的 readme 内容经过 3s 才返回
                 * 而 Repo C 的 readme 内容经过 1s 就返回（暂时不管 B）
                 * 也就是说 1s 中之后 readme 区域内容显示为 Repo C readme 内容（暂时没问题）
                 * 而再过 2s 之后 Repo A readme 内容返回（问题出现）
                 * 然后 readme 区域内容会更换为 Repo A readme 内容
                 * 此时 Repo C 为活动状态但 readme 内容为 Repo A readme 内容（错误）
                 *
                 * 解决方法就是当用户切换 repository 时就取消上个 repository （如果有）正在获取 readme 内容的 api
                 * axios 提供 Cancellation 方案处理取消 api 请求
                 */
                repoReadmeSource.cancel();
                renderedReadmeSource.cancel();
                repoReadmeSource = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.CancelToken.source();
                renderedReadmeSource = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.CancelToken.source();

                _context.prev = 6;
                _context.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_6__api__["d" /* getRepoReadme */])(repo.owner.login, repo.name, repoReadmeSource);

              case 9:
                _ref4 = _context.sent;
                content = _ref4.content;

                // 包含中文内容的 base64 解码
                // const readme = await getRenderedReadme(decodeURIComponent(escape(atob(content))), renderedReadmeSource)
                readme = converter.makeHtml(decodeURIComponent(escape(atob(content))));

                commit('changeReadme', readme);
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](6);
                response = _context.t0.response;

                if (response) commit('changeReadme', response);

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[6, 15]]);
      }))();
    },
    addRepoTag: function addRepoTag(_ref6, tagName) {
      var state = _ref6.state,
          commit = _ref6.commit,
          dispatch = _ref6.dispatch,
          rootState = _ref6.rootState;

      if (rootState.isUpdatingData) return Object(__WEBPACK_IMPORTED_MODULE_5__helper__["e" /* notifyInfo */])({ message: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('update.uncompleted') });

      var activeRepo = state.active;

      Object(__WEBPACK_IMPORTED_MODULE_5__helper__["h" /* validateTagName */])(activeRepo._customTags, tagName).then(function (name) {
        var tag = rootState.tag.tags.find(function (tag) {
          return tag.name === name;
        });
        var newTag = { id: Date.now(), name: name, repos: [activeRepo.id] };

        commit('addRepoTag', tag || newTag);
        tag ? commit('tag/addTagRepo', { tagId: tag.id, repoId: activeRepo.id }, { root: true }) : commit('tag/addTag', newTag, { root: true });

        dispatch('updateGitstarsData', {
          title: activeRepo.owner.login + ' / ' + activeRepo.name,
          message: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('addTag') + ': ' + name
        }, { root: true }).catch(function () {
          commit('popRepoTag');
          tag ? commit('tag/popTagRepo', tag.id, { root: true }) : commit('tag/popTag', null, { root: true });
        });
      }).catch(function (_ref7) {
        var message = _ref7.message;
        return Object(__WEBPACK_IMPORTED_MODULE_5__helper__["g" /* notifyWarn */])({ message: message });
      });
    },
    deleteRepoTag: function deleteRepoTag(_ref8, _ref9) {
      var state = _ref8.state,
          commit = _ref8.commit,
          dispatch = _ref8.dispatch,
          rootState = _ref8.rootState;
      var repoId = _ref9.repoId,
          tagId = _ref9.tagId;

      if (rootState.isUpdatingData) return Object(__WEBPACK_IMPORTED_MODULE_5__helper__["e" /* notifyInfo */])({ message: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('update.uncompleted') });

      var repo = state.repos.find(function (repo) {
        return repo.id === repoId;
      });
      var tagIndex = repo._customTags.findIndex(function (tag) {
        return tag.id === tagId;
      });
      var tag = rootState.tag.tags.find(function (tag) {
        return tag.id === tagId;
      });
      var repoIndex = tag.repos.findIndex(function (id) {
        return id === repoId;
      });

      commit('deleteRepoTag', { tagIndex: tagIndex, repoId: repo.id });
      commit('tag/deleteTagRepo', { repoIndex: repoIndex, tagId: tag.id }, { root: true });

      dispatch('updateGitstarsData', {
        title: repo.owner.login + ' / ' + repo.name,
        message: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('deleteTag') + ': ' + tag.name
      }, { root: true }).catch(function () {
        commit('insertRepoTag', { repo: repo, tag: tag, tagIndex: tagIndex });
        commit('tag/insertTagRepo', { repoIndex: repoIndex, tagId: tag.id, repoId: repo.id }, { root: true });
      });
    }
  }
});

/***/ }),

/***/ "28qX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepoReadmeHeader_vue__ = __webpack_require__("SWKW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d2d57c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RepoReadmeHeader_vue__ = __webpack_require__("4gLW");
function injectStyle (ssrContext) {
  __webpack_require__("q+Lt")
  __webpack_require__("opqi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d2d57c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepoReadmeHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d2d57c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RepoReadmeHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4gLW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"repo-readme__header"},[(_vm.visible)?_c('h3',{staticClass:"repo-title"},[_c('a',{attrs:{"href":_vm.activeRepo.html_url,"target":"_blank","rel":"noopener noreferrer"}},[_c('i',{staticClass:"fa fa-fw fa-lg fa-github",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.activeRepo.owner.login)+" / "+_vm._s(_vm.activeRepo.name))])]):_vm._e(),_vm._v(" "),_c('el-autocomplete',{staticClass:"repo-tag-input",attrs:{"fetch-suggestions":_vm.handleFetchTagSuggestions,"placeholder":_vm.$t('addNewTag'),"debounce":30,"size":"small","select-when-unmatched":""},on:{"select":_vm.handleAddRepoTag},model:{value:(_vm.tagName),callback:function ($$v) {_vm.tagName=$$v},expression:"tagName"}},[_c('i',{staticClass:"fa fa-fw fa-lg fa-tag el-input__icon",attrs:{"slot":"prefix"},slot:"prefix"}),_vm._v(" "),_c('el-button',{staticClass:"ttc",attrs:{"slot":"append"},on:{"click":_vm.handleAddRepoTag},slot:"append"},[_vm._v(_vm._s(_vm.$t('add')))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5te6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("SJI6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TagNavWrap__ = __webpack_require__("YH5L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomTagLabel__ = __webpack_require__("MORt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CustomTagDeleteBtn__ = __webpack_require__("ia1c");

//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cutom-tags-nav',
  components: { Draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a, TagNavWrap: __WEBPACK_IMPORTED_MODULE_3__TagNavWrap__["a" /* default */], CustomTagLabel: __WEBPACK_IMPORTED_MODULE_4__CustomTagLabel__["a" /* default */], CustomTagDeleteBtn: __WEBPACK_IMPORTED_MODULE_5__CustomTagDeleteBtn__["a" /* default */] },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])(['isEditingTags']), {
    customTags: {
      get: function get() {
        return this.$store.state.tag.tags;
      },
      set: function set(value) {
        this.$store.commit('tag/initTags', value);
      }
    },
    dragOptions: function dragOptions() {
      return { disabled: !this.isEditingTags };
    }
  })
});

/***/ }),

/***/ "6ddf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('layout-sidebar',{attrs:{"defaultTags":_vm.defaultTags,"languageTags":_vm.languageTags}}),_vm._v(" "),_c('div',{attrs:{"id":"main"}},[_c('layout-header'),_vm._v(" "),_c('div',{staticClass:"main-body"},[_c('sub-sidebar'),_vm._v(" "),_c('repo-readme')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7K/e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8G2g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubSidebarHeader_vue__ = __webpack_require__("ibeC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be0564a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubSidebarHeader_vue__ = __webpack_require__("U41Q");
function injectStyle (ssrContext) {
  __webpack_require__("n/Eu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4be0564a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubSidebarHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be0564a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubSidebarHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8dS6":
/***/ (function(module, exports) {

module.exports = Sortable;

/***/ }),

/***/ "8z31":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Tyx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("lRwf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__("Av8/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang__ = __webpack_require__("cEaa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("QmSG");





__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n___default.a({
  locale: window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].i18nLocaleKey) || 'cn',
  fallbackLocale: 'en',
  messages: __WEBPACK_IMPORTED_MODULE_2__lang__["a" /* default */]
}));

/***/ }),

/***/ "9eVl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AJSS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RepoTag__ = __webpack_require__("igwP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'repo',
  components: { RepoTag: __WEBPACK_IMPORTED_MODULE_0__RepoTag__["a" /* default */] },
  props: {
    repo: { type: Object, required: true }
  },
  methods: {
    handleSwitchActiveRepo: function handleSwitchActiveRepo() {
      this.$store.dispatch('repo/switchActive', this.repo);
    }
  }
});

/***/ }),

/***/ "Av8/":
/***/ (function(module, exports) {

module.exports = VueI18n;

/***/ }),

/***/ "B/V7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"header"}},[_c('div',{staticClass:"user-info"},[_c('a',{attrs:{"href":_vm.user.html_url,"target":"_blank","rel":"noopener noreferrer"}},[_c('img',{staticClass:"user-avatar",attrs:{"src":_vm.user.avatar_url}})]),_vm._v(" "),_c('h1',{staticClass:"user-name"},[_c('a',{attrs:{"href":((_vm.user.html_url) + "?tab=repositories"),"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.user.name)+"’s Starred Repositories")])])]),_vm._v(" "),_c('el-radio-group',{attrs:{"size":"mini"},on:{"change":_vm.handleChangeLanguage},model:{value:(_vm.currentLanguage),callback:function ($$v) {_vm.currentLanguage=$$v},expression:"currentLanguage"}},_vm._l((_vm.languages),function(language){return _c('el-radio-button',{key:language,attrs:{"label":_vm.$t(language)}})})),_vm._v(" "),_c('a',{staticClass:"octocat-link",attrs:{"href":"https://github.com/Monine/gitstars","target":"_blank","rel":"noopener noreferrer"}},[_c('svg',{staticClass:"octocat",attrs:{"width":"60","height":"60","viewBox":"0 0 250 250","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M0,0 L115,115 L130,115 L142,142 L250,250 L250,0 Z"}}),_vm._v(" "),_c('path',{staticClass:"octocat-arm",attrs:{"d":"M128.3,109.0 C113.8,99.7 119.0,89.6 119.0,89.6 C122.0,82.7 120.5,78.6 120.5,78.6 C119.2,72.0 123.4,76.3 123.4,76.3 C127.3,80.9 125.5,87.3 125.5,87.3 C122.9,97.6 130.6,101.9 134.4,103.2","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M115.0,115.0 C114.9,115.1 118.7,116.5 119.8,115.4 L133.7,101.6 C136.9,99.2 139.9,98.4 142.2,98.6 C133.8,88.0 127.5,74.4 143.8,58.0 C148.5,53.4 154.0,51.2 159.7,51.0 C160.3,49.4 163.2,43.6 171.4,40.1 C171.4,40.1 176.1,42.5 178.8,56.2 C183.1,58.6 187.2,61.8 190.9,65.4 C194.5,69.0 197.7,73.2 200.1,77.6 C213.8,80.2 216.3,84.9 216.3,84.9 C212.7,93.1 206.9,96.0 205.4,96.6 C205.1,102.4 203.0,107.8 198.3,112.5 C181.9,128.9 168.3,122.5 157.7,114.1 C157.9,116.9 156.7,120.9 152.7,124.9 L141.0,136.5 C139.8,137.7 141.6,141.9 141.8,141.8 Z","fill":"currentColor"}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BNJR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dzb6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fp48":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item",class:{ active: _vm.tag.id === _vm.activeTag.id && !_vm.isEditingTags },on:{"click":_vm.handleSwitchActiveTag}},[_vm._t("default"),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCustomTag || !_vm.isEditingTags),expression:"!isCustomTag || !isEditingTags"}],staticClass:"nav-item-badge"},[_vm._v(_vm._s(_vm.tag.repos.length))])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fs9U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GLcG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"tag-item",on:{"click":function($event){$event.stopPropagation();return _vm.handleToggleTag($event)}}},[_c('el-tag',{staticClass:"tag",class:{ clickable: !_vm.isEditingTags },attrs:{"size":"small"}},[_c('span',[_vm._v(_vm._s(_vm.tag.name))]),_vm._v(" "),_c('el-popover',{attrs:{"title":((_vm.$t('areYouSure')) + "？"),"placement":"right"},on:{"hide":_vm.handleHidePopover}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isEditingTags),expression:"!isEditingTags"}],staticClass:"tag-delete-btn",class:{ active: _vm.active },attrs:{"slot":"reference"},on:{"click":function($event){$event.stopPropagation();return _vm.handleDeleteTag($event)}},slot:"reference"},[_vm._v("×")]),_vm._v(" "),_c('footer',{staticClass:"popover-footer"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.handleCancelDeleteTag}},[_vm._v(_vm._s(_vm.$t('no')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.handleConfirmDeleteTag}},[_vm._v(_vm._s(_vm.$t('yes')))])],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GXEp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HCTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("QmSG");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-header',
  data: function data() {
    var _$i18n = this.$i18n,
        messages = _$i18n.messages,
        locale = _$i18n.locale;

    return {
      user: window._gitstars.user,
      languages: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(messages),
      currentLanguage: this.$t(locale)
    };
  },

  methods: {
    handleChangeLanguage: function handleChangeLanguage(language) {
      var texts = this.$i18n.messages[this.languages[0]];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(texts)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          if (texts[key] === language) {
            this.$i18n.locale = key;
            window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].i18nLocaleKey, key);
            return;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }
});

/***/ }),

/***/ "HrV2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagCategorys_vue__ = __webpack_require__("mmOe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70803636_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagCategorys_vue__ = __webpack_require__("Uo8W");
function injectStyle (ssrContext) {
  __webpack_require__("u32Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70803636"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagCategorys_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70803636_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagCategorys_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_notification_css__ = __webpack_require__("/I4U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_notification_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_notification_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_notification__ = __webpack_require__("yg6k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("lRwf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__("SJI6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tag__ = __webpack_require__("T2tn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__repo__ = __webpack_require__("/ULj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n__ = __webpack_require__("9Tyx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helper__ = __webpack_require__("oGFv");

















if (false) Vue.use(Vuex);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_8_vuex___default.a.Store({
  state: {
    gistId: '',
    isEditingTags: false,
    isUpdatingData: false,
    isLoadedData: false
  },
  mutations: {
    initGistId: function initGistId(state, gistId) {
      state.gistId = gistId;
    },
    toggleIsEditingTags: function toggleIsEditingTags(state) {
      var bool = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !state.isEditingTags;

      state.isEditingTags = bool;
    },
    toggleIsUpdatingData: function toggleIsUpdatingData(state) {
      var bool = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !state.isUpdatingData;

      state.isUpdatingData = bool;
    },
    toggleIsLoadedData: function toggleIsLoadedData(state) {
      var bool = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !state.isLoadedData;

      state.isLoadedData = bool;
    }
  },
  actions: {
    initGitstars: function initGitstars(_ref) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a.all([Object(__WEBPACK_IMPORTED_MODULE_14__helper__["c" /* loadReposAndLanguageTags */])(), Object(__WEBPACK_IMPORTED_MODULE_14__helper__["b" /* loadGitstarsData */])()]).then(function (_ref2) {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
            _ref3$ = _ref3[0],
            repos = _ref3$.repos,
            languageTags = _ref3$.languageTags,
            content = _ref3[1];

        var tags = content.tags;

        Object(__WEBPACK_IMPORTED_MODULE_14__helper__["a" /* formatReposTag */])(repos, tags);

        commit('repo/initRepos', repos);
        commit('tag/initTags', tags);
        commit('toggleIsLoadedData');

        return { languageTags: languageTags };
      }).catch(function () {
        return Object(__WEBPACK_IMPORTED_MODULE_14__helper__["g" /* notifyWarn */])({ title: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t('failedGetData'), message: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t('tips.refreshPage') });
      });
    },
    updateGitstarsData: function updateGitstarsData(_ref4, notify) {
      var state = _ref4.state,
          commit = _ref4.commit;

      commit('toggleIsUpdatingData');

      var loadingNotify = __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_notification___default.a.info(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].notify, {
        iconClass: 'fa fa-cog fa-spin fa-fw',
        message: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t('update.wait'),
        duration: 0
      }));

      var gist = { lastModified: Date.now(), tags: state.tag.tags };

      return Object(__WEBPACK_IMPORTED_MODULE_13__api__["h" /* saveGitstarsGist */])(gist).then(function () {
        Object(__WEBPACK_IMPORTED_MODULE_14__helper__["f" /* notifySuccess */])(notify || { message: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t('update.completed') });
        window.localStorage.setItem(window._gitstars.gistId, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(gist));
      }).catch(function () {
        var message = __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t('update.failed');
        Object(__WEBPACK_IMPORTED_MODULE_14__helper__["d" /* notifyError */])(notify || { message: message });
        throw new Error(message);
      }).finally(function () {
        commit('toggleIsUpdatingData');
        loadingNotify.close();
      });
    }
  },
  modules: { tag: __WEBPACK_IMPORTED_MODULE_9__tag__["a" /* default */], repo: __WEBPACK_IMPORTED_MODULE_10__repo__["a" /* default */] }
}));

/***/ }),

/***/ "Ig+7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JkGC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Repo_vue__ = __webpack_require__("AJSS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96c461ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Repo_vue__ = __webpack_require__("m8M5");
function injectStyle (ssrContext) {
  __webpack_require__("e9FJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-96c461ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Repo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96c461ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Repo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JzXo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_notification_css__ = __webpack_require__("/I4U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_notification_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_notification_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_notification__ = __webpack_require__("yg6k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_dropdown_item_css__ = __webpack_require__("LL4n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_dropdown_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_dropdown_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dropdown_item__ = __webpack_require__("BrEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dropdown_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dropdown_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_dropdown_menu_css__ = __webpack_require__("U/ZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_dropdown_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_dropdown_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_dropdown_menu__ = __webpack_require__("+nRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_dropdown_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_dropdown_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_dropdown_css__ = __webpack_require__("Dzb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown__ = __webpack_require__("o6kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_radio_button_css__ = __webpack_require__("bRYy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_radio_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_radio_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_radio_button__ = __webpack_require__("eBGF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_radio_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_radio_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_radio_group_css__ = __webpack_require__("BNJR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_radio_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_radio_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_radio_group__ = __webpack_require__("fDPO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_radio_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_radio_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_autocomplete_css__ = __webpack_require__("tJtB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_autocomplete_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_autocomplete_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_autocomplete__ = __webpack_require__("+vil");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_popover_css__ = __webpack_require__("8z31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_popover_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_popover_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_popover__ = __webpack_require__("SXzR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("wJKS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_tag__ = __webpack_require__("orbS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue__ = __webpack_require__("lRwf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue__);


























__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_tag___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_popover___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_autocomplete___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_radio_group___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_radio_button___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_dropdown_menu___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dropdown_item___default.a);

__WEBPACK_IMPORTED_MODULE_23_vue___default.a.prototype.$notify = __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_notification___default.a;

/***/ }),

/***/ "LL4n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_659992d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("6ddf");
function injectStyle (ssrContext) {
  __webpack_require__("OtF6")
  __webpack_require__("jko0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-659992d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_659992d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MORt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomTagLabel_vue__ = __webpack_require__("Tzgu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d402d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomTagLabel_vue__ = __webpack_require__("n6PT");
function injectStyle (ssrContext) {
  __webpack_require__("UBWf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69d402d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomTagLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d402d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomTagLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill__ = __webpack_require__("xCsw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("lRwf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__element_ui__ = __webpack_require__("JzXo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n__ = __webpack_require__("9Tyx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util__ = __webpack_require__("rQBB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__("QmSG");





var _this = this;

var accessTokenProcess = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
    var accessToken, storageCode, _parseURLSearch, code, gitstarsCode, href, response, result, _accessToken;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            accessToken = window.localStorage.getItem(localStorageKeys.accessToken);

            if (!accessToken) {
              _context.next = 3;
              break;
            }

            return _context.abrupt('return', accessToken);

          case 3:
            storageCode = window.localStorage.getItem(localStorageKeys.code);
            _parseURLSearch = Object(__WEBPACK_IMPORTED_MODULE_10__util__["a" /* parseURLSearch */])(), code = _parseURLSearch.code;
            gitstarsCode = storageCode || code;

            if (!gitstarsCode) {
              _context.next = 19;
              break;
            }

            window.localStorage.setItem(localStorageKeys.code, gitstarsCode);

            if (code) {
              href = window.location.href.replace(/code=[^&]+/, '');

              if (href[href.length - 1] === '?') href = href.slice(0, -1);
              window.history.replaceState({}, null, href);
            }

            // const { access_token: accessToken } = await getGitstarsAccessToken({
            _context.next = 11;
            return Object(__WEBPACK_IMPORTED_MODULE_11__api__["b" /* getGitstarsAccessToken */])({
              code: gitstarsCode,
              client_id: clientId,
              client_secret: clientSecret
            });

          case 11:
            response = _context.sent;
            result = {};

            response.split('&').forEach(function (item) {
              var _item$split = item.split('='),
                  _item$split2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_item$split, 2),
                  key = _item$split2[0],
                  value = _item$split2[1];

              result[key] = value;
            });
            _accessToken = result.access_token;

            window.localStorage.setItem(localStorageKeys.accessToken, _accessToken);

            return _context.abrupt('return', _accessToken);

          case 19:
            window.location.href = 'https://github.com/login/oauth/authorize?client_id=' + clientId + '&scope=gist';

          case 20:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function accessTokenProcess() {
    return _ref.apply(this, arguments);
  };
}();

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_5_vue___default.a.config.productionTip = false;

if (false) {
  require('normalize.css');
  require('font-awesome/css/font-awesome.css');
  require('github-markdown-css');
}

var clientId = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].clientId,
    clientSecret = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].clientSecret,
    localStorageKeys = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].localStorageKeys;


accessTokenProcess().then(function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(accessToken) {
    var gitstarsUser;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            gitstarsUser = window.localStorage.getItem(localStorageKeys.user);

            /**
             * 使用 axios 调用接口时做了请求拦截（api.js）
             * 请求拦截需要使用到 window._gitstars.accessToken
             * 所以下面代码两行代码不能写在一起：`window._gitstars = { accessToken, user: gitstarsUser ? JSON.parse(gitstarsUser) : await getUserInfo() }`
             * getUserInfo 接口调用时无法获取到 window._gitstars.accessToken 的值
             */

            window._gitstars = { accessToken: accessToken };

            if (!gitstarsUser) {
              _context2.next = 6;
              break;
            }

            _context2.t0 = JSON.parse(gitstarsUser);
            _context2.next = 9;
            break;

          case 6:
            _context2.next = 8;
            return Object(__WEBPACK_IMPORTED_MODULE_11__api__["g" /* getUserInfo */])();

          case 8:
            _context2.t0 = _context2.sent;

          case 9:
            window._gitstars.user = _context2.t0;


            if (!gitstarsUser) window.localStorage.setItem(localStorageKeys.user, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(window._gitstars.user));

          case 11:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}()).then(function () {
  /* eslint-disable no-new */
  new __WEBPACK_IMPORTED_MODULE_5_vue___default.a({ store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */], i18n: __WEBPACK_IMPORTED_MODULE_9__i18n__["a" /* default */], el: '#app', template: '<App/>', components: { App: __WEBPACK_IMPORTED_MODULE_8__App__["a" /* default */] } });
});

/***/ }),

/***/ "NqeX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubSidebar_vue__ = __webpack_require__("OV3H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32d44e66_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubSidebar_vue__ = __webpack_require__("+vln");
function injectStyle (ssrContext) {
  __webpack_require__("7K/e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32d44e66"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32d44e66_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OMN4":
/***/ (function(module, exports) {

module.exports = axios;

/***/ }),

/***/ "OV3H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("SJI6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubSidebarHeader__ = __webpack_require__("8G2g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Repo__ = __webpack_require__("JkGC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("QmSG");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sub-sidebar',
  components: { SubSidebarHeader: __WEBPACK_IMPORTED_MODULE_2__SubSidebarHeader__["a" /* default */], Repo: __WEBPACK_IMPORTED_MODULE_3__Repo__["a" /* default */] },
  data: function data() {
    return {
      searchValue: '',
      sortKey: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].repoSorts.time.sortKey
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])(['isLoadedData']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])('repo', { activeRepo: 'active' }), {
    repos: function repos() {
      var searchValue = this.searchValue,
          sortKey = this.sortKey;

      return this.$store.getters['repo/reposOfTag'].filter(function (repo) {
        return repo.owner.login.toLowerCase().includes(searchValue) || repo.name.toLowerCase().includes(searchValue);
      }).sort(function (a, b) {
        return b[sortKey] - a[sortKey];
      });
    }
  }),
  methods: {
    handleSwitchRepoSort: function handleSwitchRepoSort(key) {
      this.sortKey = key;
    }
  }
});

/***/ }),

/***/ "OfS6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ogc7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("SJI6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var customTagsClone = null;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tag-nav-header',
  props: {
    isCustomCategoryActive: { type: Boolean, default: false },
    tagNameFormVisible: { type: Boolean, default: false }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapState"])(['isEditingTags', 'isLoadedData']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapState"])('tag', { customTags: 'tags' })),
  methods: {
    handleAddNewTag: function handleAddNewTag() {
      if (this.isEditingTags || this.tagNameFormVisible) return;
      this.$emit('update:tagNameFormVisible', true);
    },
    handleEditTags: function handleEditTags() {
      if (this.tagNameFormVisible || !this.customTags.length) return;
      customTagsClone = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.customTags));
      this.$store.commit('toggleIsEditingTags', true);
    },
    handleCompleteEditTags: function handleCompleteEditTags() {
      var _this = this;

      this.$store.commit('toggleIsEditingTags', false);

      var isChanged = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(customTagsClone.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var index = _ref2[0];
          var _ref2$ = _ref2[1];
          var id = _ref2$.id;
          var name = _ref2$.name;

          var tag = this.customTags[index];
          if (!tag || id !== tag.id || name !== tag.name) {
            isChanged = true;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!isChanged) return;

      this.$store.dispatch('updateGitstarsData').catch(function () {
        return _this.$store.dispatch('tag/resetTags', customTagsClone);
      });
    }
  }
});

/***/ }),

/***/ "OtF6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PAbX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var SAVE = 'save';
var CANCEL = 'cancel';
var FOCUS = 'focus';
var BLUR = 'blur';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'new-tag-name-form',
  props: {
    visible: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      name: '',
      inputState: FOCUS,
      btnState: CANCEL
    };
  },

  watch: {
    visible: function visible(newValue) {
      if (newValue) this.$refs.nameInput.focus();
    }
  },
  methods: {
    handleInputTagName: function handleInputTagName() {
      this.btnState = this.name.trim().length ? SAVE : CANCEL;
    },
    handleFocusTagName: function handleFocusTagName() {
      this.inputState = FOCUS;
    },
    handleBlurTagName: function handleBlurTagName() {
      this.inputState = BLUR;
    },
    handleAddTag: function handleAddTag() {
      var _this = this;

      this.$store.dispatch('tag/addTag', this.name.trim()).then(function () {
        return _this.handleCancelAddTag();
      }).catch(function () {
        return _this.$refs.nameInput.focus();
      });
    },
    handleCancelAddTag: function handleCancelAddTag() {
      this.btnState = CANCEL;
      this.name = '';
      this.$emit('update:visible', false);
    }
  }
});

/***/ }),

/***/ "PLFR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('section',{staticClass:"repo-readme"},[_c('repo-readme-header',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSelectedRepo),expression:"isSelectedRepo"}],attrs:{"visible":_vm.isSelectedRepo,"activeRepo":_vm.activeRepo}}),_vm._v(" "),_c('article',{directives:[{name:"show",rawName:"v-show",value:(_vm.readme && !_vm.isReadmeError),expression:"readme && !isReadmeError"}],staticClass:"markdown-body",domProps:{"innerHTML":_vm._s(_vm.readme)}})],1),_vm._v(" "),(_vm.isReadmeError)?_c('div',{staticClass:"readme-error vc-p"},[_c('i',{staticClass:"fa fa-exclamation-circle fa-3x",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('p',{staticClass:"readme-error-text"},[_vm._v(_vm._s(_vm.readme.status)+" "+_vm._s(_vm.readme.statusText))])]):_vm._e(),_vm._v(" "),_c('section',{directives:[{name:"show",rawName:"v-show",value:(!_vm.readme),expression:"!readme"}],staticClass:"waiting vc-p"},[_c('h4',{staticClass:"readme"},[_vm._v("README.md")]),_vm._v(" "),_c('p',{staticClass:"loader"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSelectedRepo && !_vm.readme),expression:"isSelectedRepo && !readme"}],staticClass:"fa fa-cog fa-spin fa-2x fa-fw"}),_vm._v(" "),(!_vm.isSelectedRepo)?_c('span',[_c('i',{staticClass:"fa fa-hand-o-left fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"ttc"},[_vm._v(_vm._s(_vm.$t('clickLeftStarredRepoToView')))])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QmSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var clientId = isProduction ? 'e4eade59975433c57dc0' : '65cb868a7f39130f09ac';
var clientSecret = isProduction ? 'dc97c18949f327bb4bcac59d0c8f6bedc030c7ac' : '42336bf045880b746ed4b097a6ea56111cca13c1';

/* harmony default export */ __webpack_exports__["a"] = ({
  clientId: clientId,
  clientSecret: clientSecret,
  localStorageKeys: {
    gistId: 'gitstars_gist_id',
    accessToken: 'gitstars_access_token',
    code: 'gitstars_code',
    user: 'gitstars_user'
  },
  filename: 'gitstars.json',
  description: 'github stars manager for ' + "production",
  notify: {
    duration: 3000,
    showClose: false,
    position: 'bottom-right'
  },
  starredReposPerPage: 100, // Github 最大值
  i18nLocaleKey: 'gitstars_i18n_local',
  defaultTags: {
    all: { id: 0, i18nKey: 'allRepos', icon: 'fa-bars' },
    untagged: { id: -1, i18nKey: 'untaggedRepos', icon: 'fa-star-o' }
  },
  tagCategorys: {
    custom: { id: 0, name: '自定义', i18nKey: 'custom' },
    language: { id: 1, name: '语言', i18nKey: 'language' }
  },
  repoSorts: {
    time: { id: 0, sortKey: '_sortTime', name: '时间', i18nKey: 'time', icon: 'fa-clock-o' },
    star: { id: 1, sortKey: 'stargazers_count', name: 'star', icon: 'fa-star' }
  }
});

/***/ }),

/***/ "Qn3e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-popover',{attrs:{"title":((_vm.$t('areYouSure')) + "？"),"placement":"right"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"fa fa-times-circle",attrs:{"slot":"reference","aria-hidden":"true"},on:{"click":function($event){$event.stopPropagation();return _vm.handleDeleteTag($event)}},slot:"reference"}),_vm._v(" "),_c('footer',{staticClass:"popover-footer"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.handleCancelDeleteTag}},[_vm._v(_vm._s(_vm.$t('no')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.handleConfirmDeleteTag}},[_vm._v(_vm._s(_vm.$t('yes')))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SJI6":
/***/ (function(module, exports) {

module.exports = Vuex;

/***/ }),

/***/ "SWKW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'repo-readme-header',
  props: {
    visible: { type: Boolean, default: false },
    activeRepo: { type: Object, required: true }
  },
  data: function data() {
    return {
      tagName: ''
    };
  },

  computed: {
    currentRepoUntaggedTags: function currentRepoUntaggedTags() {
      var _this = this;

      return this.$store.state.tag.tags.filter(function (tag) {
        return !_this.activeRepo._customTags.find(function (_ref) {
          var id = _ref.id;
          return id === tag.id;
        });
      }).map(function (_ref2) {
        var name = _ref2.name;
        return name;
      });
    }
  },
  methods: {
    handleFetchTagSuggestions: function handleFetchTagSuggestions(inputStr, cb) {
      inputStr = inputStr.toLowerCase();
      cb(this.currentRepoUntaggedTags.filter(function (name) {
        return name.toLowerCase().includes(inputStr);
      }).map(function (name) {
        return { value: name };
      }));
    },
    handleAddRepoTag: function handleAddRepoTag() {
      this.$store.dispatch('repo/addRepoTag', this.tagName.trim());
      this.tagName = '';
    }
  }
});

/***/ }),

/***/ "T2tn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n__ = __webpack_require__("9Tyx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__("oGFv");






/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    tags: [],
    active: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].defaultTags.all
  },
  mutations: {
    initTags: function initTags(state, tags) {
      state.tags = tags;
    },
    switchActive: function switchActive(state, tag) {
      state.active = tag;
    },
    changeTagName: function changeTagName(state, _ref) {
      var tagId = _ref.tagId,
          name = _ref.name;

      var tag = state.tags.find(function (tag) {
        return tag.id === tagId;
      });
      tag.name = name;
    },
    addTag: function addTag(state, tag) {
      state.tags.push(tag);
    },
    popTag: function popTag(state) {
      state.tags.pop();
    },
    deleteTag: function deleteTag(state, tagId) {
      var tags = state.tags;

      var index = tags.findIndex(function (tag) {
        return tag.id === tagId;
      });
      tags.splice(index, 1);
    },
    addTagRepo: function addTagRepo(state, _ref2) {
      var tagId = _ref2.tagId,
          repoId = _ref2.repoId;

      var tag = state.tags.find(function (tag) {
        return tag.id === tagId;
      });
      tag.repos.push(repoId);
    },
    insertTagRepo: function insertTagRepo(state, _ref3) {
      var tagId = _ref3.tagId,
          repoIndex = _ref3.repoIndex,
          repoId = _ref3.repoId;

      var tag = state.tags.find(function (tag) {
        return tag.id === tagId;
      });
      tag.repos.splice(repoIndex, 0, repoId);
    },
    popTagRepo: function popTagRepo(state, tagId) {
      var tag = state.tags.find(function (tag) {
        return tag.id === tagId;
      });
      tag.repos.pop();
    },
    deleteTagRepo: function deleteTagRepo(state, _ref4) {
      var tagId = _ref4.tagId,
          repoIndex = _ref4.repoIndex;

      var tag = state.tags.find(function (tag) {
        return tag.id === tagId;
      });
      tag.repos.splice(repoIndex, 1);
    }
  },
  actions: {
    resetTags: function resetTags(_ref5, tags) {
      var commit = _ref5.commit,
          rootState = _ref5.rootState;

      /**
       * 当用户编辑 tags 完成之后确认更新数据
       * 如果更新数据接口出错
       * 则还原编辑操作之前 tags 数据的同时还需还原每个 repository 上的 _customTags 数据
       * 因为 _customTags 内保存的是每一个 tag 对象的引用
       * 修改标签名就是直接修改 tag 对象的 name 属性
       * 而还原 tags 数据则是对 tags 重新赋值
       * 此时 repository 上的 _customTags 集合内项目依然是之前 tags 集合项目的引用
       *
       * 目前的解决办法是使用 formatReposTag 方法重新格式化每个 repository 内的 _customTags 集合
       */
      commit('initTags', tags);
      Object(__WEBPACK_IMPORTED_MODULE_4__helper__["a" /* formatReposTag */])(rootState.repo.repos, tags);
    },
    addTag: function addTag(_ref6, tag) {
      var _this = this;

      var state = _ref6.state,
          commit = _ref6.commit,
          dispatch = _ref6.dispatch,
          rootState = _ref6.rootState;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var message;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!rootState.isUpdatingData) {
                  _context.next = 4;
                  break;
                }

                message = __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('update.uncompleted');

                Object(__WEBPACK_IMPORTED_MODULE_4__helper__["e" /* notifyInfo */])({ message: message });
                throw new Error(message);

              case 4:

                if (typeof tag === 'string') tag = { id: Date.now(), name: tag, repos: [] };

                return _context.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_4__helper__["h" /* validateTagName */])(state.tags, tag.name).then(function (name) {
                  commit('addTag', tag);
                  dispatch('updateGitstarsData', { message: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('addTag') + ': ' + name }, { root: true }).catch(function () {
                    return commit('popTag');
                  });
                }).catch(function (_ref7) {
                  var message = _ref7.message;

                  Object(__WEBPACK_IMPORTED_MODULE_4__helper__["g" /* notifyWarn */])({ message: message });
                  throw new Error(message);
                }));

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    changeTagName: function changeTagName(_ref8, _ref9) {
      var state = _ref8.state,
          commit = _ref8.commit;
      var tagId = _ref9.tagId,
          name = _ref9.name;

      return Object(__WEBPACK_IMPORTED_MODULE_4__helper__["h" /* validateTagName */])(state.tags, name).then(function (name) {
        commit('changeTagName', { tagId: tagId, name: name });
      });
    },
    deleteTag: function deleteTag(_ref10, tagId) {
      var commit = _ref10.commit;

      commit('deleteTag', tagId);
      commit('repo/deleteReposTag', tagId, { root: true });
    }
  }
});

/***/ }),

/***/ "TfWi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tjut":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  tags: '标签集',
  add: '添加',
  ok: '完成',
  cancel: '取消',
  yes: '是',
  no: '否',
  save: '保存',
  custom: '自定义',
  language: '语言',
  developer: '开发者',
  sort: '排序',
  time: '时间',

  addTag: '@:add标签',
  addNewTag: '新增标签',
  deleteTag: '删除标签',
  repositoryName: '仓库名',
  allRepos: '全部',
  untaggedRepos: '未标签',
  tagName: '标签名称',
  tagNameCannotEmpty: '@:tagName不能为空',
  tagNameAlreadyExist: '已存在此标签',
  clickLeftStarredRepoToView: '点击左侧 Starred 仓库查看',
  noMatchingReposigory: '没有匹配仓库',
  switchTagOrAdjustSearch: '切换标签 或 调整搜索',
  gettingStarredRepository: '正在获取 Starred 仓库 ...',
  canNotSwitchTagWhenEdit: '@:edit.default状态下不能切换标签',
  areYouSure: '确定删除',
  failedGetData: '获取数据失败',

  update: {
    default: '更新',
    wait: '正在@:update.default，请稍候 ...',
    uncompleted: '前置@:update.default尚未完成，请稍候 ...',
    completed: '@:update.default成功',
    failed: '@:update.default失败'
  },
  edit: {
    default: '编辑',
    completed: '@:edit.default标签@:ok'
  },
  tips: {
    editTag: '双击标签修改名称 | 拖拽标签排列顺序',
    refreshPage: '建议刷新页面'
  }
});

/***/ }),

/***/ "TtQ1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomTagsNav_vue__ = __webpack_require__("5te6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_181c01be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomTagsNav_vue__ = __webpack_require__("h7BN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomTagsNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_181c01be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomTagsNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tzgu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__("oGFv");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var preName = '';
var isChangeTagNameByEnter = false;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'custom-tag-label',
  props: {
    tag: { type: Object, required: true },
    isEditingTags: { type: Boolean, default: false }
  },
  data: function data() {
    var tag = this.tag;

    return {
      isEditing: false,
      name: tag.name,
      ref: 'tagNameEditInput' + tag.id
    };
  },

  methods: {
    handleEditTagName: function handleEditTagName() {
      var _this = this;

      if (!this.isEditingTags) return;

      this.name = preName = this.tag.name;
      this.isEditing = true;
      this.$nextTick(function () {
        return _this.$refs[_this.ref].focus();
      });
    },
    handleChangeTagNameByBlur: function handleChangeTagNameByBlur() {
      var _this2 = this;

      if (isChangeTagNameByEnter) return isChangeTagNameByEnter = false;

      this.$store.dispatch('tag/changeTagName', { tagId: this.tag.id, name: this.name }).then(function () {
        return _this2.isEditing = false;
      }).catch(function () {
        _this2.name = preName;
        _this2.isEditing = false;
      });
    },
    handleChangeTagNameByEnter: function handleChangeTagNameByEnter() {
      var _this3 = this;

      if (this.name === this.tag.name) return this.isEditing = false;

      this.$store.dispatch('tag/changeTagName', { tagId: this.tag.id, name: this.name }).then(function () {
        isChangeTagNameByEnter = true;
        _this3.isEditing = false;
      }).catch(function (_ref) {
        var message = _ref.message;
        return Object(__WEBPACK_IMPORTED_MODULE_0__helper__["g" /* notifyWarn */])({ message: message });
      });
    },
    handleCancelEditTagName: function handleCancelEditTagName() {
      this.isEditing = false;
      this.name = preName;
    }
  }
});

/***/ }),

/***/ "U/ZW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U41Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"subsidebar-header"}},[_c('label',{staticClass:"search-label"},[_c('i',{staticClass:"fa fa-search",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('input',{staticClass:"search-input",attrs:{"placeholder":((_vm.$t('developer')) + " | " + (_vm.$t('repositoryName')) + " @" + (_vm.activeTag.i18nKey ? _vm.$t(_vm.activeTag.i18nKey) : _vm.activeTag.name)),"type":"text"},domProps:{"value":_vm.searchValue},on:{"input":_vm.handleInputSearchValue}})]),_vm._v(" "),_c('el-dropdown',{staticClass:"sort-drapdown",on:{"command":_vm.handleSortRepos}},[_c('div',{staticClass:"sort-drapdown-link"},[_vm._v(_vm._s(_vm.$t('sort'))+" "),_c('i',{staticClass:"el-icon-arrow-down"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown","id":"subsidebar-header__dropdown-menu"},slot:"dropdown"},_vm._l((_vm.repoSorts),function(sort){return _c('el-dropdown-item',{key:sort.id,attrs:{"command":sort.sortKey}},[_c('i',{staticClass:"fa",class:sort.icon,attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"subsidebar-header__dropdown-menu--text"},[_vm._v(_vm._s(_vm.$t(sort.i18nKey) || sort.name))])])}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UBWf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uo8W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tag-category"},[_c('li',{staticClass:"tag-category__slider",style:(_vm.sliderStyle)}),_vm._v(" "),_vm._l((_vm.categorys),function(category,key){return _c('li',{key:key,staticClass:"tag-category__item",class:{ active: category.id === _vm.activeTagCategory.id },on:{"click":function($event){_vm.handleSwitchCategory(category)}}},[_vm._v("\n    "+_vm._s(_vm.$t(category.i18nKey))+"\n  ")])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WFw0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("SJI6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__("oGFv");

//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tag-nav-wrap',
  props: {
    tag: { type: Object, required: true },
    isCustomTag: { type: Boolean, default: false }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])(['isEditingTags']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])('tag', { activeTag: 'active' })),
  methods: {
    handleSwitchActiveTag: function handleSwitchActiveTag() {
      if (this.isEditingTags) return Object(__WEBPACK_IMPORTED_MODULE_2__helper__["e" /* notifyInfo */])({ message: this.$t('canNotSwitchTagWhenEdit') });
      this.$store.commit('tag/switchActive', this.tag);
    }
  }
});

/***/ }),

/***/ "X+ky":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y2i4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'custom-tag-nav',
  props: {
    tag: { type: Object, required: true },
    visible: { type: Boolean, default: false }
  },
  methods: {
    handleDeleteTag: function handleDeleteTag() {
      document.body.click();
    },
    handleCancelDeleteTag: function handleCancelDeleteTag() {
      document.body.click();
    },
    handleConfirmDeleteTag: function handleConfirmDeleteTag() {
      document.body.click();
      this.$store.dispatch('tag/deleteTag', this.tag.id);
    }
  }
});

/***/ }),

/***/ "YH5L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagNavWrap_vue__ = __webpack_require__("WFw0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4485e6e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagNavWrap_vue__ = __webpack_require__("Fp48");
function injectStyle (ssrContext) {
  __webpack_require__("bWUr")
  __webpack_require__("Fs9U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4485e6e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagNavWrap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4485e6e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagNavWrap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z155":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZWyH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  cn: '中文',
  en: 'English'
});

/***/ }),

/***/ "ZqQ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewTagNameForm_vue__ = __webpack_require__("PAbX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ae9061e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewTagNameForm_vue__ = __webpack_require__("o+d+");
function injectStyle (ssrContext) {
  __webpack_require__("TfWi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ae9061e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewTagNameForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ae9061e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewTagNameForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bRYy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bWUr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bwYh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tags-nav"},_vm._l((_vm.tags),function(tag){return _c('tag-nav-wrap',{key:tag.id,attrs:{"tag":tag}},[_c('div',{staticClass:"nav-item__label slo"},[_c('i',{staticClass:"fa fa-fw",class:("" + (tag.icon || 'fa-tag')),attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"nav-item__name slo"},[_vm._v(_vm._s(tag.name || _vm.$t(tag.i18nKey)))])])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cEaa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__("ZWyH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cn__ = __webpack_require__("Tjut");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__en__ = __webpack_require__("p9le");






var i18n = { cn: __WEBPACK_IMPORTED_MODULE_3__cn__["a" /* default */], en: __WEBPACK_IMPORTED_MODULE_4__en__["a" /* default */] };
__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(i18n).forEach(function (language) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(language, __WEBPACK_IMPORTED_MODULE_2__base__["a" /* default */]);
});

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),

/***/ "e9FJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f/Jg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TagNavWrap__ = __webpack_require__("YH5L");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tags-nav',
  components: { TagNavWrap: __WEBPACK_IMPORTED_MODULE_0__TagNavWrap__["a" /* default */] },
  props: {
    tags: { type: Array, required: true }
  }
});

/***/ }),

/***/ "f2Ne":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("SJI6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__("oGFv");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'repo-tag',
  data: function data() {
    return {
      active: false
    };
  },

  props: {
    repo: { type: Object, required: true },
    tag: { type: Object, required: true }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])(['isEditingTags'])),
  methods: {
    handleToggleTag: function handleToggleTag() {
      if (this.isEditingTags) return Object(__WEBPACK_IMPORTED_MODULE_2__helper__["e" /* notifyInfo */])({ message: this.$t('canNotSwitchTagWhenEdit') });
      this.$store.commit('tag/switchActive', this.tag);
    },
    handleDeleteTag: function handleDeleteTag() {
      document.body.click();
      this.active = true;
    },
    handleCancelDeleteTag: function handleCancelDeleteTag() {
      document.body.click();
    },
    handleConfirmDeleteTag: function handleConfirmDeleteTag() {
      document.body.click();
      this.$store.dispatch('repo/deleteRepoTag', { repoId: this.repo.id, tagId: this.tag.id });
    },
    handleHidePopover: function handleHidePopover() {
      this.active = false;
    }
  }
});

/***/ }),

/***/ "f3NK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("SJI6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TagsNav__ = __webpack_require__("x9Q7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TagNavHeader__ = __webpack_require__("/QRR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NewTagNameForm__ = __webpack_require__("ZqQ4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CustomTagsNav__ = __webpack_require__("TtQ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TagCategorys__ = __webpack_require__("HrV2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__("QmSG");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  components: { TagsNav: __WEBPACK_IMPORTED_MODULE_2__TagsNav__["a" /* default */], TagNavHeader: __WEBPACK_IMPORTED_MODULE_3__TagNavHeader__["a" /* default */], NewTagNameForm: __WEBPACK_IMPORTED_MODULE_4__NewTagNameForm__["a" /* default */], CustomTagsNav: __WEBPACK_IMPORTED_MODULE_5__CustomTagsNav__["a" /* default */], TagCategorys: __WEBPACK_IMPORTED_MODULE_6__TagCategorys__["a" /* default */] },
  props: {
    defaultTags: { type: Array, required: true },
    languageTags: { type: Array, required: true }
  },
  data: function data() {
    var tagCategorys = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].tagCategorys;

    return {
      tagCategorys: tagCategorys,
      activeTagCategory: __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].tagCategorys.custom,
      tagNameFormVisible: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])(['isEditingTags', 'isLoadedData']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])('tag', { customTags: 'tags' }), {
    isCustomCategoryActive: function isCustomCategoryActive() {
      return this.activeTagCategory === this.tagCategorys.custom;
    }
  })
});

/***/ }),

/***/ "h7BN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('draggable',{staticClass:"custom-tags",attrs:{"list":_vm.customTags,"options":_vm.dragOptions}},[_c('transition-group',{staticClass:"tags-nav",attrs:{"name":"tag-nav","tag":"ul"}},_vm._l((_vm.customTags),function(tag){return _c('tag-nav-wrap',{key:tag.id,attrs:{"tag":tag,"is-custom-tag":""}},[_c('custom-tag-label',{attrs:{"tag":tag,"isEditingTags":_vm.isEditingTags}}),_vm._v(" "),_c('custom-tag-delete-btn',{attrs:{"visible":_vm.isEditingTags,"tag":tag}})],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ia1c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomTagDeleteBtn_vue__ = __webpack_require__("Y2i4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b83258e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomTagDeleteBtn_vue__ = __webpack_require__("Qn3e");
function injectStyle (ssrContext) {
  __webpack_require__("9eVl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b83258e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomTagDeleteBtn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b83258e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomTagDeleteBtn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ibeC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("SJI6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("QmSG");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sub-sidebar-header',
  props: {
    searchValue: { type: String, default: '' }
  },
  data: function data() {
    return {
      repoSorts: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].repoSorts
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])('tag', { activeTag: 'active' })),
  methods: {
    handleInputSearchValue: function handleInputSearchValue(event) {
      this.$emit('update:searchValue', event.target.value.toLowerCase());
    },
    handleSortRepos: function handleSortRepos(key) {
      this.$emit('onSwitchRepoSort', key);
    }
  }
});

/***/ }),

/***/ "igwP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepoTag_vue__ = __webpack_require__("f2Ne");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73a0e60d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RepoTag_vue__ = __webpack_require__("GLcG");
function injectStyle (ssrContext) {
  __webpack_require__("Z155")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73a0e60d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepoTag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73a0e60d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RepoTag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jVG5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jko0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lQzl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-caption"},[_c('h3',{staticClass:"nav-caption__title"},[_c('i',{staticClass:"fa fa-fw fa-tags",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('tags').toUpperCase()))])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-to-left"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoadedData && _vm.isCustomCategoryActive),expression:"isLoadedData && isCustomCategoryActive"}],staticClass:"nav-caption__operate"},[_c('div',{staticClass:"nav-caption__operate-btn",class:{ disabled: _vm.isEditingTags || _vm.tagNameFormVisible },on:{"click":_vm.handleAddNewTag}},[_c('span',[_c('i',{staticClass:"fa fa-plus-square",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('add')))])]),_vm._v(" "),_c('transition-group',{staticClass:"nav-caption__group--edit-ok",attrs:{"name":"enlarge","tag":"div"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isEditingTags),expression:"isEditingTags"}],key:"ok",staticClass:"nav-caption__operate-btn nav-caption__ok-btn",on:{"click":_vm.handleCompleteEditTags}},[_c('span',[_vm._v(_vm._s(_vm.$t('ok').toUpperCase()))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isEditingTags),expression:"!isEditingTags"}],key:"edit",staticClass:"nav-caption__operate-btn",class:{ disabled: _vm.tagNameFormVisible || !_vm.customTags.length },on:{"click":_vm.handleEditTags}},[_c('span',[_c('i',{staticClass:"fa fa-cog",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('edit.default')))])])])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lRwf":
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),

/***/ "lZ5c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("f3NK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24b7c82c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("z8kP");
function injectStyle (ssrContext) {
  __webpack_require__("jVG5")
  __webpack_require__("rp3A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24b7c82c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24b7c82c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m8M5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"repo-item",on:{"click":_vm.handleSwitchActiveRepo}},[_c('header',[_c('h3',{staticClass:"repo-title"},[_c('a',{attrs:{"href":_vm.repo.html_url,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.repo.owner.login)+" / "+_vm._s(_vm.repo.name))]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.repo.homepage),expression:"repo.homepage"}],attrs:{"href":_vm.repo.homepage,"target":"_blank","rel":"noopener noreferrer"}},[_c('i',{staticClass:"fa fa-fw fa-lg fa-home",attrs:{"aria-hidden":"true"}})])])]),_vm._v(" "),_c('p',{staticClass:"repo-desc"},[_vm._v(_vm._s(_vm.repo.description))]),_vm._v(" "),_c('ul',{staticClass:"tag-list"},_vm._l((_vm.repo._customTags),function(tag){return _c('repo-tag',{key:tag.id,attrs:{"repo":_vm.repo,"tag":tag}})})),_vm._v(" "),_c('footer',{staticClass:"repo-footer"},[_c('span',{staticClass:"repo-star"},[_c('i',{staticClass:"fa fa-star",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.repo.stargazers_count))]),_vm._v(" "),_c('span',{staticClass:"repo-fork"},[_c('i',{staticClass:"fa fa-code-fork",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.repo.forks_count))]),_vm._v(" "),_c('span',{staticClass:"repo-language"},[_vm._v(_vm._s(_vm.repo.language))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mmOe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tag-categorys',
  props: {
    categorys: { type: Array, required: true },
    activeTagCategory: { type: Object, required: true }
  },
  computed: {
    sliderStyle: function sliderStyle() {
      var _this = this;

      var slidebarWidth = 100 / this.categorys.length;
      var index = this.categorys.findIndex(function (category) {
        return category.id === _this.activeTagCategory.id;
      });
      return { left: index * slidebarWidth + '%', width: slidebarWidth + '%' };
    }
  },
  methods: {
    handleSwitchCategory: function handleSwitchCategory(category) {
      this.$emit('update:activeTagCategory', category);
    }
  }
});

/***/ }),

/***/ "n/Eu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n5Qe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getGitstarsAccessToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createGitstarsGist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getGitstarsGist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getUserGists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getStarredRepos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getRepoReadme; });
/* unused harmony export getRenderedReadme */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return saveGitstarsGist; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("OMN4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("QmSG");




// import { Notification } from 'element-ui'


__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.baseURL = 'https://api.github.com';

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.request.use(function (config) {
  if (config.url.includes('http')) return config;

  config.url += config.url.includes('?') ? '&' : '?';
  config.url += 'access_token=' + window._gitstars.accessToken;
  return config;
}, function (err) {
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(err);
});

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.response.use(function (_ref) {
  var data = _ref.data;

  return data;
}, function (err) {
  // let message = err.message
  // const { response = {} } = err
  // const { config, data, status, statusText } = response

  // if (!err.__CANCEL__ && !/(\/repos\/).+(\/readme)/.test(config.url)) {
  //   if (data) message = data.message
  //   Notification.error({ message, title: `${status} ${statusText}`, showClose: false })
  // }

  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(err);
});

var filename = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].filename,
    description = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].description,
    starredReposPerPage = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].starredReposPerPage;

// 感谢 imsun (https://github.com/imsun) 提供获取 access token 服务
// export const getGitstarsAccessToken = params => axios.post('https://gh-oauth.imsun.net', params)

var getGitstarsAccessToken = function getGitstarsAccessToken(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('https://cors-anywhere.herokuapp.com/https://github.com/login/oauth/access_token', data);
};

// https://developer.github.com/v3/users/#get-the-authenticated-user
var getUserInfo = function getUserInfo() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/user');
};

// https://developer.github.com/v3/gists/#create-a-gist
var createGitstarsGist = function createGitstarsGist(content) {
  // Gitstars v2 修改 public 属性为 false（API 默认）
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/gists', {
    description: description,
    // public: true,
    files: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, filename, {
      content: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(content)
    })
  });
};

// https://developer.github.com/v3/gists/#get-a-single-gist
var getGitstarsGist = function getGitstarsGist(id) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/gists/' + id);
};

// https://developer.github.com/v3/gists/#list-a-users-gists
var getUserGists = function getUserGists() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/users/' + window._gitstars.user.login + '/gists');
};

// https://developer.github.com/v3/activity/starring/#list-repositories-being-starred
var getStarredRepos = function getStarredRepos(page) {
  var params = { page: page, per_page: starredReposPerPage };
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/users/' + window._gitstars.user.login + '/starred', { params: params });
};

// https://developer.github.com/v3/repos/contents/#get-the-readme
var getRepoReadme = function getRepoReadme(login, name, source) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/repos/' + login + '/' + name + '/readme', { cancelToken: source.token });
};

// https://developer.github.com/v3/markdown/#render-a-markdown-document-in-raw-mode
var getRenderedReadme = function getRenderedReadme(data, source) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default()({
    data: data,
    url: '/markdown/raw',
    method: 'post',
    headers: {
      'Content-Type': 'text/plain'
    },
    cancelToken: source.token
  });
};

// https://developer.github.com/v3/gists/
var saveGitstarsGist = function saveGitstarsGist(content) {
  // return axios.patch(`/gists/${window._gitstars.gistId + 'a'}`, {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.patch('/gists/' + window._gitstars.gistId, {
    files: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, filename, {
      content: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(content)
    })
  });
};

/***/ }),

/***/ "n6PT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-item__label slo",on:{"dblclick":_vm.handleEditTagName}},[_c('i',{staticClass:"fa fa-fw fa-tag",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isEditing),expression:"!isEditing"}],staticClass:"nav-item__name slo"},[_vm._v(_vm._s(_vm.tag.name))]),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(_vm.isEditing),expression:"isEditing"},{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],ref:_vm.ref,staticClass:"nav-item__input--name",attrs:{"type":"text"},domProps:{"value":(_vm.name)},on:{"blur":_vm.handleChangeTagNameByBlur,"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleChangeTagNameByEnter($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }return _vm.handleCancelEditTagName($event)}],"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o+d+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"tag-form",attrs:{"onsubmit":"return false"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],ref:"nameInput",staticClass:"tag-form__input--name",class:_vm.inputState,attrs:{"placeholder":("" + (_vm.$t('tagName'))),"type":"text"},domProps:{"value":(_vm.name)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.name=$event.target.value},_vm.handleInputTagName],"focus":_vm.handleFocusTagName,"blur":_vm.handleBlurTagName,"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.handleAddTag($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }return _vm.handleCancelAddTag($event)}]}}),_vm._v(" "),_c('div',{staticClass:"tag-form__operate",class:_vm.btnState},[_c('button',{staticClass:"tag-form__operate-btn save",attrs:{"type":"button"},on:{"click":_vm.handleAddTag}},[_vm._v(_vm._s(_vm.$t('save')))]),_vm._v(" "),_c('button',{staticClass:"tag-form__operate-btn cancel",attrs:{"type":"button"},on:{"click":_vm.handleCancelAddTag}},[_vm._v(_vm._s(_vm.$t('cancel')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oGFv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadReposAndLanguageTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadGitstarsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatReposTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return validateTagName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return notifySuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return notifyInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return notifyWarn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return notifyError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_notification_css__ = __webpack_require__("/I4U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_notification_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_notification_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_notification__ = __webpack_require__("yg6k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__("OMN4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n__ = __webpack_require__("9Tyx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api__ = __webpack_require__("n5Qe");










var _this = this;







var loadReposAndLanguageTags = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var repos, reposByPage, sortNum, dateNow, languageTags;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            repos = [];
            reposByPage = [];
            sortNum = 999999999;

          case 3:
            _context.next = 5;
            return Object(__WEBPACK_IMPORTED_MODULE_12__api__["e" /* getStarredRepos */])(page++);

          case 5:
            reposByPage = _context.sent;

            reposByPage.forEach(function (repo, index) {
              repo._customTags = [];
              repo[__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].repoSorts.time.sortKey] = sortNum--;
            });
            repos.push.apply(repos, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(reposByPage));

          case 8:
            if (reposByPage.length === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].starredReposPerPage) {
              _context.next = 3;
              break;
            }

          case 9:
            dateNow = Date.now();
            languageTags = [];


            repos.forEach(function (_ref2) {
              var repoId = _ref2.id,
                  language = _ref2.language;

              if (!language) return;

              var languageTag = languageTags.find(function (tag) {
                return tag.name === language;
              });
              if (languageTag) {
                languageTag.repos.push(repoId);
              } else {
                languageTags.push({
                  id: dateNow,
                  categoryId: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].tagCategorys.language.id,
                  name: language,
                  repos: [repoId]
                });
                dateNow += 1;
              }
            });

            return _context.abrupt('return', { repos: repos, languageTags: languageTags });

          case 13:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function loadReposAndLanguageTags() {
    return _ref.apply(this, arguments);
  };
}();

var loadGitstarsData = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee2() {
    var gitstarsGistId, content, isUseStorageContent, _ref4, files, contentFromStorage, gists, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref5, id, description, _files, _ref6, _id;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            gitstarsGistId = window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].localStorageKeys.gistId);
            content = null;
            isUseStorageContent = false;

            if (!gitstarsGistId) {
              _context2.next = 13;
              break;
            }

            _context2.next = 6;
            return Object(__WEBPACK_IMPORTED_MODULE_12__api__["c" /* getGitstarsGist */])(gitstarsGistId);

          case 6:
            _ref4 = _context2.sent;
            files = _ref4.files;

            content = JSON.parse(files[__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].filename].content);

            contentFromStorage = window.localStorage.getItem(gitstarsGistId);

            if (contentFromStorage) {
              contentFromStorage = JSON.parse(contentFromStorage);
              /**
               * 客户端之间 localStorage 内保存的数据不共享
               * 需要对比远程数据（使用 lastModified 值）确定最新数据
               *
               * 为什么不能直接使用远程数据？
               *
               * 因为 github api 有 60s 缓存
               * 如果用户更新数据后不久再执行刷新操作
               * 远程数据不一定返回上次更新的最新数据
               *
               * 还有一种情况是无法避免的
               * 用户使用 chrome 和 firefox 同时打开 gitstars
               * 用户在 chrome 客户端更新数据
               * 然后在 60s 之内使用 firefox 客户端刷新页面
               * firefox 客户端获取的远程 gist 数据不一定是 chrome 客户端更新后的最新数据
               */
              if (contentFromStorage.lastModified > content.lastModified) {
                content = contentFromStorage;
                isUseStorageContent = true;
              }
            }
            _context2.next = 55;
            break;

          case 13:
            _context2.next = 15;
            return Object(__WEBPACK_IMPORTED_MODULE_12__api__["f" /* getUserGists */])();

          case 15:
            gists = _context2.sent;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context2.prev = 19;
            _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(gists);

          case 21:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context2.next = 33;
              break;
            }

            _ref5 = _step.value;
            id = _ref5.id, description = _ref5.description, _files = _ref5.files;

            if (!(description === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].description)) {
              _context2.next = 30;
              break;
            }

            gitstarsGistId = id;
            _context2.next = 28;
            return __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(_files[__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].filename].raw_url);

          case 28:
            content = _context2.sent;
            return _context2.abrupt('break', 33);

          case 30:
            _iteratorNormalCompletion = true;
            _context2.next = 21;
            break;

          case 33:
            _context2.next = 39;
            break;

          case 35:
            _context2.prev = 35;
            _context2.t0 = _context2['catch'](19);
            _didIteratorError = true;
            _iteratorError = _context2.t0;

          case 39:
            _context2.prev = 39;
            _context2.prev = 40;

            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }

          case 42:
            _context2.prev = 42;

            if (!_didIteratorError) {
              _context2.next = 45;
              break;
            }

            throw _iteratorError;

          case 45:
            return _context2.finish(42);

          case 46:
            return _context2.finish(39);

          case 47:
            if (gitstarsGistId) {
              _context2.next = 54;
              break;
            }

            content = { lastModified: Date.now(), tags: [] };
            _context2.next = 51;
            return Object(__WEBPACK_IMPORTED_MODULE_12__api__["a" /* createGitstarsGist */])(content);

          case 51:
            _ref6 = _context2.sent;
            _id = _ref6.id;

            gitstarsGistId = _id;

          case 54:

            window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].localStorageKeys.gistId, gitstarsGistId);

          case 55:

            if (!isUseStorageContent) window.localStorage.setItem(gitstarsGistId, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(content));

            window._gitstars.gistId = gitstarsGistId;
            return _context2.abrupt('return', content);

          case 58:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[19, 35, 39, 47], [40,, 42, 46]]);
  }));

  return function loadGitstarsData() {
    return _ref3.apply(this, arguments);
  };
}();

var formatReposTag = function formatReposTag(repos, tags) {
  repos.forEach(function (repo) {
    if (repo._customTags.length) repo._customTags = [];
  });

  tags.forEach(function (tag) {
    tag.repos.forEach(function (repoId, index, tagRepos) {
      var repo = repos.find(function (_ref7) {
        var id = _ref7.id;
        return id === repoId;
      });
      repo ? repo._customTags.push(tag) : tagRepos[index] = undefined;
    });
    tag.repos = tag.repos.filter(function (repo) {
      return repo;
    });
  });
};

var validateTagName = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee3(tags, name) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (name) {
              _context3.next = 2;
              break;
            }

            throw new Error(__WEBPACK_IMPORTED_MODULE_10__i18n__["a" /* default */].t('tagNameCannotEmpty'));

          case 2:
            if (!tags.find(function (tag) {
              return tag.name === name;
            })) {
              _context3.next = 4;
              break;
            }

            throw new Error(__WEBPACK_IMPORTED_MODULE_10__i18n__["a" /* default */].t('tagNameAlreadyExist'));

          case 4:
            return _context3.abrupt('return', name);

          case 5:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function validateTagName(_x2, _x3) {
    return _ref8.apply(this, arguments);
  };
}();

var notifySuccess = function notifySuccess(notify) {
  return __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_notification___default.a.success(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, notify, __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].notify));
};
var notifyInfo = function notifyInfo(notify) {
  return __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_notification___default.a.info(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, notify, __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].notify));
};
var notifyWarn = function notifyWarn(notify) {
  return __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_notification___default.a.warning(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, notify, __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].notify));
};
var notifyError = function notifyError(notify) {
  return __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_notification___default.a.error(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, notify, __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].notify));
};

/***/ }),

/***/ "opqi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p9le":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  tags: 'tags',
  add: 'add',
  ok: 'ok',
  cancel: 'cancel',
  yes: 'yes',
  no: 'no',
  save: 'save',
  custom: 'custom',
  language: 'language',
  developer: 'Developer',
  sort: 'sort',
  time: 'time',

  addTag: 'Add Tag',
  addNewTag: 'Add New Tag',
  deleteTag: 'Delete Tag',
  repositoryName: 'Repository Name',
  allRepos: 'All Stars',
  untaggedRepos: 'Untagged Stars',
  tagName: 'Tag Name',
  tagNameCannotEmpty: 'Tag name can not be empty',
  tagNameAlreadyExist: 'This tag already exists',
  clickLeftStarredRepoToView: 'Click left starred repository to view',
  noMatchingReposigory: 'No matching repository',
  switchTagOrAdjustSearch: 'Switch Tag or Adjust Search',
  gettingStarredRepository: 'Getting starred repositories ...',
  canNotSwitchTagWhenEdit: 'Edit state can not switch tag',
  areYouSure: 'Are you sure',
  failedGetData: 'Failed to get data',

  update: {
    default: 'update',
    wait: 'Updating. please wait...',
    uncompleted: 'Pre-upgrade has not been completed, please wait ...',
    completed: 'Update completed',
    failed: 'Update failed'
  },
  edit: {
    default: 'edit',
    completed: 'Edit tag completed'
  },
  tips: {
    editTag: 'Double-click change name | Drag sort order',
    refreshPage: 'Recommend to refresh the page'
  }
});

/***/ }),

/***/ "q+Lt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qASp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/app-name.50561f6.png";

/***/ }),

/***/ "rQBB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parseURLSearch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

var parseURLSearch = function parseURLSearch() {
  var searchStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.search;

  var search = {};

  if (!searchStr.length) return search;
  if (searchStr[0] === '?') searchStr = searchStr.slice(1);

  var kvs = searchStr.split('&');
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(kvs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var kv = _step.value;

      var skv = kv.split('=');
      search[skv[0]] = decodeURIComponent(skv[1]);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return search;
};

/***/ }),

/***/ "rp3A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tJtB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "teIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("HCTz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2de914a5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("B/V7");
function injectStyle (ssrContext) {
  __webpack_require__("Ig+7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2de914a5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2de914a5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u32Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ulMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("SJI6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RepoReadmeHeader__ = __webpack_require__("28qX");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'repo-readme',
  components: { RepoReadmeHeader: __WEBPACK_IMPORTED_MODULE_3__RepoReadmeHeader__["a" /* default */] },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapState"])('repo', { readme: 'readme', activeRepo: 'active' }), {
    isSelectedRepo: function isSelectedRepo() {
      return !!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.activeRepo).length;
    },
    isReadmeError: function isReadmeError() {
      return typeof this.readme !== 'string';
    }
  })
});

/***/ }),

/***/ "wJKS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wnWb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x9Q7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagsNav_vue__ = __webpack_require__("f/Jg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7693f932_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagsNav_vue__ = __webpack_require__("bwYh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagsNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7693f932_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagsNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xCsw":
/***/ (function(module, exports) {

module.exports = _babelPolyfill;

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Sidebar__ = __webpack_require__("lZ5c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SubSidebar__ = __webpack_require__("NqeX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_RepoReadme__ = __webpack_require__("ykPa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__("QmSG");

//
//
//
//
//
//
//
//
//
//
//
//
//







var _defaultTags = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].defaultTags;


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  components: { LayoutSidebar: __WEBPACK_IMPORTED_MODULE_1__components_Sidebar__["a" /* default */], LayoutHeader: __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */], SubSidebar: __WEBPACK_IMPORTED_MODULE_3__components_SubSidebar__["a" /* default */], RepoReadme: __WEBPACK_IMPORTED_MODULE_4__components_RepoReadme__["a" /* default */] },
  data: function data() {
    return {
      languageTags: []
    };
  },

  computed: {
    defaultTags: function defaultTags() {
      return [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _defaultTags.all, { repos: this.$store.state.repo.repos }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _defaultTags.untagged, { repos: this.$store.getters['repo/untaggedRepos'] })];
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch('initGitstars').then(function (tags) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this, tags);
    });
  }
});

/***/ }),

/***/ "ykPa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepoReadme_vue__ = __webpack_require__("ulMJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12d21c91_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RepoReadme_vue__ = __webpack_require__("PLFR");
function injectStyle (ssrContext) {
  __webpack_require__("wnWb")
  __webpack_require__("OfS6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12d21c91"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepoReadme_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12d21c91_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RepoReadme_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z8kP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sidebar"}},[_vm._m(0),_vm._v(" "),_c('tags-nav',{staticClass:"default-tags",attrs:{"tags":_vm.defaultTags}}),_vm._v(" "),_c('div',{staticClass:"sidebar-main"},[_c('tag-nav-header',{attrs:{"isCustomCategoryActive":_vm.isCustomCategoryActive,"tagNameFormVisible":_vm.tagNameFormVisible},on:{"update:tagNameFormVisible":function($event){_vm.tagNameFormVisible=$event}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('new-tag-name-form',{directives:[{name:"show",rawName:"v-show",value:(_vm.tagNameFormVisible),expression:"tagNameFormVisible"}],attrs:{"visible":_vm.tagNameFormVisible},on:{"update:visible":function($event){_vm.tagNameFormVisible=$event}}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isEditingTags),expression:"isEditingTags"}],staticClass:"edit-tag-tip"},[_vm._v(_vm._s(_vm.$t('tips.editTag')))])]),_vm._v(" "),_c('div',{staticClass:"tag-list__group"},[_c('transition',{attrs:{"name":"slide-to-left"}},[_c('custom-tags-nav',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCustomCategoryActive),expression:"isCustomCategoryActive"}]})],1),_vm._v(" "),_c('transition',{attrs:{"name":"slide-to-right"}},[_c('tags-nav',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTagCategory.id === _vm.tagCategorys.language.id),expression:"activeTagCategory.id === tagCategorys.language.id"}],staticClass:"language-tags",attrs:{"tags":_vm.languageTags}})],1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"telescopic"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoadedData && !_vm.customTags.length && _vm.isCustomCategoryActive),expression:"isLoadedData && !customTags.length && isCustomCategoryActive"}],staticClass:"no-tag vc-p"},[_c('i',{staticClass:"fa fa-hand-o-up fa-2x",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('addTag')))])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('tag-categorys',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoadedData && !_vm.isEditingTags && !_vm.tagNameFormVisible),expression:"isLoadedData && !isEditingTags && !tagNameFormVisible"}],attrs:{"categorys":Object.values(_vm.tagCategorys),"activeTagCategory":_vm.activeTagCategory},on:{"update:activeTagCategory":function($event){_vm.activeTagCategory=$event}}})],1),_vm._v(" "),_vm._m(1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticStyle:{"display":"none"}},[_vm._v("Github Stars Manager")]),_vm._v(" "),_c('a',{attrs:{"href":"https://github.com/Monine/gitstars","target":"_blank","rel":"noopener noreferrer"}},[_c('img',{staticClass:"app-name-img",attrs:{"src":__webpack_require__("qASp"),"alt":"app name"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"sidebar-footer"},[_c('span',[_vm._v("Author : ")]),_vm._v(" "),_c('h1',{staticClass:"author"},[_c('a',{staticClass:"author-name",attrs:{"href":"https://github.com/Monine","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Monine")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// assets/js/app.a98d7f08f51e354cbe66.js